(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/race-history-extended.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/race-history-extended.js');

'use strict';

const RaceHistoryExtendedItem = svs.racing_game.components.statistics.RaceHistoryExtendedItem;
const RaceHistoryExtended = _ref => {
  let {
    isTrotting,
    isGallop,
    participants
  } = _ref;
  return React.createElement("div", {
    className: "race-history-row race-history-list-expanded fc-navy"
  }, React.createElement("div", {
    className: "race-history-list-expanded"
  }, React.createElement("div", {
    className: "race-history-list-items fc-racing-900"
  }, React.createElement("div", {
    className: "race-history-row race-history-header"
  }, React.createElement("div", {
    className: "horse-history-column drop-down"
  }, "Plac."), React.createElement("div", {
    className: "horse-history-column horse-info"
  }, "Ekipage"), isGallop && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "horse-history-column distance-to-winner"
  }, "Avs."), React.createElement("div", {
    className: "horse-history-column start-gate"
  }, "Startbox")), React.createElement("div", {
    className: "horse-history-column ".concat(participants[0].trotting ? 'kilometer-time' : 'riders-weight')
  }, isTrotting ? 'Tid' : 'Ridvikt (kg)'), React.createElement("div", {
    className: "horse-history-column prize-money"
  }, "Prispengar"), React.createElement("div", {
    className: "horse-history-column race-distance"
  }), React.createElement("div", {
    className: "horse-history-column race-dicipline"
  }), React.createElement("div", {
    className: "horse-history-column finish-place"
  })), participants.map(participant => React.createElement(RaceHistoryExtendedItem, {
    key: "".concat(participant.horseName, "_").concat(participant.driverName, "_").concat(participant.earnings),
    participant: participant
  })))));
};
svs.racing_game.components.statistics.RaceHistoryExtended = RaceHistoryExtended;

 })(window);